import { supabase } from '../../lib/supabase';
import type { Saved } from '../../store/game';

let timer: ReturnType<typeof setTimeout> | null = null;
/** Cloud-Speicherstand, entprellt: höchstens alle 3 Sekunden ein Schreibzugriff. */
export function cloudSaveDebounced(saved: Saved) {
  if (!supabase) return;
  if (timer) clearTimeout(timer);
  timer = setTimeout(async () => {
    const { data: u } = await supabase!.auth.getUser(); if (!u.user) return;
    await supabase!.from('saves').upsert({ user_id: u.user.id, slot: 1, state: saved.state, journal: saved.journal, updated_at: new Date().toISOString() }, { onConflict: 'user_id,slot' });
  }, 3000);
}
export async function cloudLoad(): Promise<Saved | null> {
  if (!supabase) return null;
  const { data: u } = await supabase.auth.getUser(); if (!u.user) return null;
  const { data } = await supabase.from('saves').select('state,journal,updated_at').eq('user_id', u.user.id).eq('slot', 1).maybeSingle();
  return data?.state ? { state: data.state, journal: Array.isArray(data.journal) ? data.journal : [] } : null;
}
